import httpService from './core/http.service';

class TaxonomyService {
    route = '/taxonomy';

    getTaxonomy = () => httpService.get(`${this.route}`);
}

export default new TaxonomyService();
